"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ALIASES = [
    'matches',
    'webkitMatchesSelector',
    'mozMatchesSelector',
    'msMatchesSelector',
];
var matchesSelectorFn;
if (typeof HTMLElement !== 'undefined') {
    for (var i = 0; i < ALIASES.length; i++) {
        matchesSelectorFn = Element.prototype[ALIASES[i]];
        if (matchesSelectorFn) {
            break;
        }
    }
}
var isElementMatchesSelector = matchesSelectorFn
    ? function (element, selector) {
        return matchesSelectorFn.call(element, selector);
    }
    : function (element, selector) {
        return Array.prototype.indexOf.call(document.querySelectorAll(selector), element) !== -1;
    };
exports.default = isElementMatchesSelector;
//# sourceMappingURL=isElementMatchesSelector.js.map